import { createI18n } from 'vue-i18n'
import en from './en.json'
import ar from './ar.json'

export default createI18n({
  legacy: false, // ضروري ليعمل مع Vue 3 Composition API
  locale: 'en', // اللغة الافتراضية عند تحميل التطبيق
  fallbackLocale: 'en', // اللغة التي سيتم استخدامها إذا كانت الترجمة غير موجودة
  messages: {
    en: en,
    ar: ar
  }
})